import { generateUUID, performDraw, startSessionManagement } from '@datadog/browser-core';
import { LifeCycleEventType } from './lifeCycle';
export var RUM_SESSION_KEY = 'rum';
export var RumSessionPlan;
(function (RumSessionPlan) {
    RumSessionPlan[RumSessionPlan["LITE"] = 1] = "LITE";
    RumSessionPlan[RumSessionPlan["REPLAY"] = 2] = "REPLAY";
})(RumSessionPlan || (RumSessionPlan = {}));
export var RumTrackingType;
(function (RumTrackingType) {
    RumTrackingType["NOT_TRACKED"] = "0";
    // Note: the "tracking type" value (stored in the session cookie) does not match the "session
    // plan" value (sent in RUM events). This is expected, and was done to keep retrocompatibility
    // with active sessions when upgrading the SDK.
    RumTrackingType["TRACKED_REPLAY"] = "1";
    RumTrackingType["TRACKED_LITE"] = "2";
})(RumTrackingType || (RumTrackingType = {}));
export function startRumSession(configuration, lifeCycle) {
    var session = startSessionManagement(configuration.cookieOptions, RUM_SESSION_KEY, function (rawTrackingType) {
        return computeSessionState(configuration, rawTrackingType);
    });
    session.renewObservable.subscribe(function () {
        lifeCycle.notify(LifeCycleEventType.SESSION_EXPIRED);
        lifeCycle.notify(LifeCycleEventType.SESSION_RENEWED);
    });
    return {
        getId: session.getId,
        isTracked: function () { return isSessionTracked(session); },
        hasReplayPlan: function () { return isSessionTracked(session) && session.getTrackingType() === RumTrackingType.TRACKED_REPLAY; },
        hasLitePlan: function () { return isSessionTracked(session) && session.getTrackingType() === RumTrackingType.TRACKED_LITE; },
    };
}
/**
 * Start a tracked replay session stub
 * It needs to be a replay plan in order to get long tasks
 */
export function startRumSessionStub() {
    return {
        getId: function () { return generateUUID(); },
        isTracked: function () { return true; },
        hasReplayPlan: function () { return true; },
        hasLitePlan: function () { return false; },
    };
}
function isSessionTracked(session) {
    return session.getId() !== undefined && isTypeTracked(session.getTrackingType());
}
function computeSessionState(configuration, rawTrackingType) {
    var trackingType;
    if (hasValidRumSession(rawTrackingType)) {
        trackingType = rawTrackingType;
    }
    else if (!performDraw(configuration.sampleRate)) {
        trackingType = RumTrackingType.NOT_TRACKED;
    }
    else if (!performDraw(configuration.replaySampleRate)) {
        trackingType = RumTrackingType.TRACKED_LITE;
    }
    else {
        trackingType = RumTrackingType.TRACKED_REPLAY;
    }
    return {
        trackingType: trackingType,
        isTracked: isTypeTracked(trackingType),
    };
}
function hasValidRumSession(trackingType) {
    return (trackingType === RumTrackingType.NOT_TRACKED ||
        trackingType === RumTrackingType.TRACKED_REPLAY ||
        trackingType === RumTrackingType.TRACKED_LITE);
}
function isTypeTracked(rumSessionType) {
    return rumSessionType === RumTrackingType.TRACKED_LITE || rumSessionType === RumTrackingType.TRACKED_REPLAY;
}
//# sourceMappingURL=rumSession.js.map